import React from 'react';
import {CSSTransition, Transition, TransitionGroup} from "react-transition-group";
import stars from '../../images/space/stars.png'

import uuid from 'uuid'



function Stars(props) {

    const renderSheep = () => {
        if (true) {
            return  (

                <div>
                    <img src={stars} style={sheep}/>
                </div>


            )
        }
    }

    return(
        <TransitionGroup>
            <CSSTransition
                key={uuid()}
                timeout={600}
                classNames='fade'>
                {renderSheep}
            </CSSTransition>
        </TransitionGroup>

    )

}


export default Stars



const sheep = {
    position: 'fixed',
    zIndex: -1,
    maxHeight: '90%',
    maxWidth:'100%',
    left:'0',
    right:'0',
    top:'0',
    bottom:'0',
    margin:'auto'
}

